// Comment structure reference: { name: string, date: string, time: string, message: string, avatar: string }
// {
// name: 'John Smith',
// date: '01 January, 2026',
// time: '10:00 am',
// message: '...',
// avatar: '/assets/img/content/comment-img-02.png',
// },
const COMMENTS_TEMPLATE = [];

const cloneComments = () => COMMENTS_TEMPLATE.map((comment) => ({ ...comment }));

export const ARTICLE_POSTS = [
  {
    id: 'automation-workflows-scalable-operations',
    category: 'Workflow Automation and Operations',
    author: 'Nalexus Technologies',
    title: 'Automation Workflows: From Manual Chaos to Scalable Operations',
    description:
      'Learn how to identify automation-ready processes, design scalable workflows, handle exceptions, and measure impact beyond time saved.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'January 8, 2026',
    wowDelay: '200ms',
    wowDir: 'fadeInLeft',
    comments: cloneComments(),
  },
  {
    id: 'designing-ai-systems-business-problems',
    category: 'AI Systems and Generative AI',
    author: 'Nalexus Technologies',
    title: 'Designing AI Systems That Solve Business Problems',
    description:
      'A practical guide to designing AI systems: use case selection, data readiness, guardrails, deployment, monitoring, and real business metrics.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'January 11, 2026',
    wowDelay: '250ms',
    wowDir: 'fadeInUp',
    comments: cloneComments(),
  },
  {
    id: 'generative-ai-in-production',
    category: 'AI Systems and Generative AI',
    author: 'Nalexus Technologies',
    title: 'Generative AI in Production: What Actually Works Today',
    description:
      'What works with GenAI in production today: proven use cases, RAG basics, guardrails, evaluation, and cost and latency controls.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'January 15, 2026',
    wowDelay: '200ms',
    wowDir: 'fadeInRight',
    comments: cloneComments(),
  },
  {
    id: 'cms-2026-content-architecture',
    category: 'Content Platforms and Digital Experience',
    author: 'Nalexus Technologies',
    title: 'CMS in 2026: Choosing the Right Content Architecture for Growth',
    description:
      'Choose the right CMS architecture for growth: traditional, headless, hybrid, and composable models, with SEO, governance, and migration tips.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'January 18, 2026',
    wowDelay: '220ms',
    wowDir: 'fadeInLeft',
    comments: cloneComments(),
  },
  {
    id: 'saas-architecture-explained',
    category: 'Software Architecture and Engineering Excellence',
    author: 'Nalexus Technologies',
    title: 'SaaS Architecture Explained: From MVP to Multi-Tenant Scale',
    description:
      'From MVP to multi-tenant scale: SaaS architecture essentials, data isolation options, identity, billing, observability, and reliability patterns.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'January 22, 2026',
    wowDelay: '280ms',
    wowDir: 'fadeInUp',
    comments: cloneComments(),
  },
  {
    id: 'building-software-that-lasts',
    category: 'Software Architecture and Engineering Excellence',
    author: 'Nalexus Technologies',
    title: 'Building Software That Lasts: Engineering for Maintainability',
    description:
      'Build software that stays easy to change: boundaries, testing strategy, observability, refactoring tactics, and realistic technical debt control.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'January 26, 2026',
    wowDelay: '200ms',
    wowDir: 'fadeInRight',
    comments: cloneComments(),
  },
  {
    id: 'ai-plus-automation',
    category: 'Workflow Automation and Operations',
    author: 'Nalexus Technologies',
    title: 'AI + Automation: When to Combine Them and When Not To',
    description:
      'Decide when to use automation, AI, or both: hybrid patterns, guardrails, metrics, and common failure modes to avoid.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'January 30, 2026',
    wowDelay: '260ms',
    wowDir: 'fadeInLeft',
    comments: cloneComments(),
  },
  {
    id: 'enterprise-application-development',
    category: 'Enterprise Systems and Data Foundations',
    author: 'Nalexus Technologies',
    title: 'Enterprise Application Development: From Requirements to Reality',
    description:
      'Turn enterprise requirements into working systems: discovery, domain modeling, integrations, security, delivery strategy, and change management.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'February 2, 2026',
    wowDelay: '300ms',
    wowDir: 'fadeInUp',
    comments: cloneComments(),
  },
  {
    id: 'data-as-a-product',
    category: 'Enterprise Systems and Data Foundations',
    author: 'Nalexus Technologies',
    title: 'Data as a Product: Structuring Data for AI and Analytics',
    description:
      'Treat data as a product: ownership, modeling, quality checks, semantic metrics, pipelines, and AI-ready feature and label governance.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'February 5, 2026',
    wowDelay: '200ms',
    wowDir: 'fadeInRight',
    comments: cloneComments(),
  },
  {
    id: 'ai-readiness-assessment',
    category: 'AI Systems and Generative AI',
    author: 'Nalexus Technologies',
    title: 'AI Readiness Assessment: Is Your Organization Actually Ready?',
    description:
      'Assess AI readiness across business, data, platform, people, and risk, with a practical scoring model and clear go or no-go criteria.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'February 8, 2026',
    wowDelay: '220ms',
    wowDir: 'fadeInLeft',
    comments: cloneComments(),
  },
  {
    id: 'api-first-development',
    category: 'Software Architecture and Engineering Excellence',
    author: 'Nalexus Technologies',
    title: 'API-First Development: The Backbone of Modern Software',
    description:
      'Design APIs as contracts: REST, GraphQL, events, versioning, idempotency, security, documentation, and observability for scale.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'February 11, 2026',
    wowDelay: '280ms',
    wowDir: 'fadeInUp',
    comments: cloneComments(),
  },
  {
    id: 'security-by-design',
    category: 'Security, Governance, and Trust',
    author: 'Nalexus Technologies',
    title: 'Security by Design: Building Trust Into Software Systems',
    description:
      'Build security into architecture and delivery: IAM, data protection, secure SDLC, monitoring, incident readiness, and SaaS tenant isolation.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'February 14, 2026',
    wowDelay: '200ms',
    wowDir: 'fadeInRight',
    comments: cloneComments(),
  },
  {
    id: 'automation-roi',
    category: 'Workflow Automation and Operations',
    author: 'Nalexus Technologies',
    title: 'Automation ROI: Proving Value Beyond Cost Savings',
    description:
      'Prove automation ROI beyond cost savings: throughput, quality, cycle time, risk reduction, and a defensible measurement framework.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'February 18, 2026',
    wowDelay: '240ms',
    wowDir: 'fadeInLeft',
    comments: cloneComments(),
  },
  {
    id: 'choosing-right-tech-stack',
    category: 'Software Architecture and Engineering Excellence',
    author: 'Nalexus Technologies',
    title: 'Choosing the Right Tech Stack: A Practical Decision Framework',
    description:
      'A decision framework for tech stacks: constraints, team fit, TCO, lock-in tradeoffs, and patterns that scale without over-engineering.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'February 21, 2026',
    wowDelay: '300ms',
    wowDir: 'fadeInUp',
    comments: cloneComments(),
  },
  {
    id: 'future-of-it-consulting',
    category: 'Consulting and Delivery Partnerships',
    author: 'Nalexus Technologies',
    title: 'The Future of IT Consulting: From Vendors to Strategic Partners',
    description:
      'How IT consulting is evolving: outcome-based delivery, AI and automation maturity, governance, documentation, and partner-grade engagement models.',
    img: '/assets/img/banners/articles.png',
    heroImg: '/assets/img/content/blog-dt-01.png',
    date: 'February 25, 2026',
    wowDelay: '200ms',
    wowDir: 'fadeInRight',
    comments: cloneComments(),
  },
];

export const CATEGORIES = [
  'All',
  'Workflow Automation and Operations',
  'AI Systems and Generative AI',
  'Software Architecture and Engineering Excellence',
  'Enterprise Systems and Data Foundations',
  'Content Platforms and Digital Experience',
  'Security, Governance, and Trust',
  'Consulting and Delivery Partnerships',
];

